import TfwLogo from "./TfwLogo";

export default TfwLogo;
